// extracted by mini-css-extract-plugin
var _1 = "ProfileContactsWidgetListCellNoValue-modulecell__DrJMy ProfileContactsWidgetListCell-modulecell__WYdgk";
var _2 = "ProfileContactsWidgetListCellNoValue-modulecontent__QUxMi ProfileContactsWidgetListCellView-modulecontent__xMal2";
var _3 = "ProfileContactsWidgetListCellNoValue-moduledivider__BhIBo ProfileContactsWidgetListCell-moduledivider__p3o1g Divider-moduleDivider__dL3Vg";
var _4 = "ProfileContactsWidgetListCellNoValue-modulelabel__uaYtW ProfileContactsWidgetListCellView-modulelabel__mWNoG";
var _5 = "ProfileContactsWidgetListCellNoValue-modulerow__sCosj";
export { _1 as "cell", _2 as "content", _3 as "divider", _4 as "label", _5 as "row" }
